<template>
  <!-- 웹: 컨퍼런스 네비게이션 (앱은 네비게이션 없이 노출) -->
  <TNavComponent v-if="!isApp" />
  <div class="flex flex-1 bg-white">
    <div class="w-full max-w-[40rem] px-4 sm:px-6 mx-auto">
      <EduRegisterDonePage/>
    </div>
  </div>
</template>

<script>
// import LNavComponent from "@/components/LNavComponent.vue";
import TNavComponent from "@/components/new/TNavComponent.vue";
import EduRegisterDonePage from "@/pages/EduRegisterConfirmPage.vue";

export default {
  name: "EduRegisterConfirmView",
  components: {TNavComponent, EduRegisterDonePage},
  computed: {
    isApp() {
      return this.$route.name === "eduRegisterDoneApp";
    },
  },
}
</script>

<style scoped>

</style>
